import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { ResetIcon } from './icons/reset-icon';
import { SearchIcon } from './icons/search-icon';
import messages from './messages';
import style from './style.module.less';

const AdvancedSearchBase = ({ filterComponents, onSubmit, onReset }) => {
  const onSubmitWrapper = useCallback(
    (e) => {
      e.preventDefault();
      return onSubmit(e);
    },
    [onSubmit],
  );

  return (
    <form onSubmit={onSubmitWrapper}>
      <div className={style['advanced-search-base']}>
        {filterComponents.map((Filter, index) => (
          <Filter key={index} shouldSendFocusToInput={index === 0} />
        ))}
        <div className={style['button-wrapper']}>
          <Button
            className={classNames(style.button, style['reset-button'])}
            id='advanced-search-reset-button'
            onClick={onReset}
            testId='advanced-search-reset-button'
            theme='tertiary'
          >
            <ResetIcon />
            <FormattedMessage {...messages.reset} />
          </Button>
          <Button
            className={style.button}
            id='advanced-search-submit-button'
            pendoTrackingId='advanced-search-button'
            testId='advanced-search-submit-button'
            theme='primary'
            type='submit'
          >
            <SearchIcon />
            <FormattedMessage {...messages.search} />
          </Button>
        </div>
      </div>
    </form>
  );
};

AdvancedSearchBase.propTypes = {
  filterComponents: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default AdvancedSearchBase;
